@if (router.url !== '/') {
    <div class="special-offer-container">
        @if (packages.length > 0) {
            <div class="published">
                <div class="pub-container">
                    <div class="pub-title">
                        <h3>{{ homeConfig.name | uppercase }}</h3>
                    </div>
                    <div class="discount-text">
                        <b>
                            {{ 'shoppingCart.freeDelivery' | translate }}
                            <a href="https://jogkodex.hu/jsz/2024_13_torveny_6486371?ts=kozlony#pl9%C2%A7" target="_blank"
                                ><mat-icon>info</mat-icon></a
                            >
                        </b>
                    </div>
                </div>
            </div>
        }
        @if (packages.length > 0) {
            <div class="materials-container-special-offer">
                <div class="material-container-published">
                    <div class="package-container">
                        @for (package of packages; track package) {
                            <app-product-preview [product]="package" (addToCart)="addToCartPackage($event)" />
                        }
                    </div>
                </div>
            </div>
        }
    </div>
}

@if (router.url === '/' && packages.length > 0) {
    <div class="special-offer-container-home">
        <div class="published">
            <pf-offer-header
                [title]="'specialOffer.discountedPackages'"
                [translateTitle]="true"
                [lines]="offerLinesActive() ? offerLines() : []"
            />
        </div>
        <div class="materials-container-special-offer">
            <div class="material-container-published">
                <div class="package-container">
                    @for (package of packages; track package) {
                        <app-product-preview [product]="package" (addToCart)="addToCartPackage($event)" />
                    }
                </div>
            </div>
        </div>
    </div>
}
